import { defaultTqcGaugeCalibPlanDto, TqcGaugeCalibPlanDto } from 'src/dtos/tqcGaugeCalibPlan/tqcGaugeCalibPlanDto';

export interface EQM3010_R01Dto extends TqcGaugeCalibPlanDto {
	compNm: string;
	equipmentNm: string;
	gaugeCalibDt: string;
	gaugeCalibPlanDt: string;
}

export const defaultEQM3010_R01Dto: EQM3010_R01Dto = {
	...defaultTqcGaugeCalibPlanDto,
	compCd: '',
	compNm: '',
	equipmentNm: '',
	gaugeCalibDt: '',
	gaugeCalibPlanDt: '',
};
